import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { TypedDocumentNode } from '@apollo/client';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostRequestMutation extends AbstractGraphqlRequest<PostModel> {
  protected override type: GraphqlRequestType = 'mutation';

  protected override getQuery(payload: any): TypedDocumentNode<any, any> {
    if (payload.data?.id) {
      return gql`
        mutation updatePost($data: PostUpdateInput!) {
          updatePost(data: $data) {
            id
            category {
              id
              title
              description
            }
            cover {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            picture {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            pictures {
              id
              name
              originalName
              extension
              active
              title
              description
              directory
              directories
              chunkEnd
              chunkStart
              frontUrls

              mimetype
              temp
              createdAt
              updatedAt
              createdBy
              updatedBy
            }
            slug
            title
            description
            shortDescription
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      `;
    }

    return gql`
      mutation createPost($data: PostCreateInput!) {
        createPost(data: $data) {
          id
          category {
            id
            title
            description
          }
          cover {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          picture {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          pictures {
            id
            name
            originalName
            extension
            active
            title
            description
            directory
            directories
            chunkEnd
            chunkStart
            frontUrls

            mimetype
            temp
            createdAt
            updatedAt
            createdBy
            updatedBy
          }
          slug
          title
          description
          shortDescription
          active
          createdAt
          updatedAt
          deletedAt
          createdBy
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const postData = data.createPost || data.updatePost;

    if (postData) {
      return new PostModel(postData);
    }

    return null;
  }
}
